/* Kaliva – couche de comportement des sections "kv-*" (clone Resilia).
   Écrit pour le thème Shrine : Swiper (jsDelivr), sélecteur d'offres, cadeaux, panier (cart-drawer Shrine). */
(function () {
  'use strict';
  var KV = (window.KVResilia = window.KVResilia || {});

  /* ---------------------------------------------------------------- Swiper loader */
  KV.swiperReady = KV.swiperReady || new Promise(function (resolve, reject) {
    if (typeof window.Swiper === 'function') return resolve(window.Swiper);
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    s.async = true;
    s.onload = function () { resolve(window.Swiper); };
    s.onerror = function () { reject(new Error('Swiper introuvable')); };
    document.head.appendChild(s);
  });
  KV.run = function (cb) {
    KV.swiperReady.then(function (Swiper) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { cb(Swiper); }, { once: true });
      else cb(Swiper);
    }).catch(function (e) { console.error('[KV]', e); });
  };
  KV.onReady = function (cb) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cb, { once: true });
    else cb();
  };

  /* ---------------------------------------------------------------- helpers */
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
  function easeOutQuad(t) { return 1 - (1 - t) * (1 - t); }

  /* ---------------------------------------------------------------- video play buttons (all sections) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kv-rs .custom-play-button');
    if (!btn) return;
    var wrapper = btn.closest('.video-wrapper');
    var video = wrapper ? wrapper.querySelector('video') : null;
    if (!video) return;
    qsa(document, '.kv-rs video').forEach(function (v) {
      if (v !== video) {
        v.pause();
        v.controls = false;
        var w = v.closest('.video-wrapper');
        var wp = w && w.querySelector('.kv-video-poster');
        if (wp) wp.style.display = '';
        var b = w && w.querySelector('.custom-play-button');
        if (b) { b.style.display = ''; b.style.opacity = ''; }
      }
    });
    if (video.paused) {
      var kvPoster = wrapper.querySelector('.kv-video-poster');
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(function () {
          video.muted = false;
          video.controls = true;
          if (kvPoster) kvPoster.style.display = 'none';
          btn.style.display = 'none';
          video.onpause = function () { btn.style.display = ''; btn.style.opacity = ''; video.controls = false; if (kvPoster) kvPoster.style.display = ''; };
        }).catch(function () {
          video.muted = true;
          var retry = video.play();
          if (retry !== undefined) {
            retry.then(function () {
              video.controls = true;
              if (kvPoster) kvPoster.style.display = 'none';
              btn.style.display = 'none';
              video.onpause = function () { btn.style.display = ''; btn.style.opacity = ''; video.controls = false; if (kvPoster) kvPoster.style.display = ''; };
            }).catch(function () {});
          }
        });
      }
    } else {
      video.pause();
    }
  });

  /* ---------------------------------------------------------------- section initialisers */
  var inits = {};

  // Bandeau défilant : CSS animation only – nothing to do.

  // Compteurs animés
  inits['.clinical-proven-section'] = function (section) {
    var parse = function (el) {
      var raw = (el.getAttribute('data-target') || '').trim();
      var m = raw.match(/^(\D*)([\d.,\s]+)(.*)$/);
      if (!m) return null;
      var trail = (m[2].match(/\s+$/) || [''])[0];
      var prefix = m[1] || '', numeric = m[2].replace(/[\s,]/g, ''), suffix = trail + (m[3] || '');
      var hasDecimal = numeric.indexOf('.') > -1;
      var target = hasDecimal ? parseFloat(numeric) : parseInt(numeric, 10);
      if (isNaN(target)) return null;
      var decimals = hasDecimal ? (numeric.split('.')[1] || '').length : 0;
      var fmt = function (v) {
        var n = decimals ? v.toFixed(decimals) : String(Math.round(v));
        // séparateur de milliers : espace fine en français, virgule dans les autres langues
        var lang = (document.documentElement.lang || 'fr').toLowerCase();
        var sep = lang.indexOf('fr') === 0 ? ' ' : ',';
        return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      };
      return { prefix: prefix, target: target, suffix: suffix, fmt: fmt };
    };
    var stats = qsa(section, '.stat-percentage');
    stats.forEach(function (el) { var p = parse(el); if (p) el.textContent = p.prefix + p.fmt(0) + p.suffix; });
    var animate = function (el) {
      var p = parse(el); if (!p) return;
      var duration = p.target <= 100 ? 1000 : 1800, start = performance.now();
      var step = function (now) {
        var pr = Math.max(0, Math.min((now - start) / duration, 1));
        el.textContent = p.prefix + p.fmt(easeOutQuad(pr) * p.target) + p.suffix;
        if (pr < 1) requestAnimationFrame(step); else el.textContent = p.prefix + p.fmt(p.target) + p.suffix;
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { stats.forEach(animate); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        stats.forEach(function (el) { if (!el.classList.contains('counted')) { el.classList.add('counted'); animate(el); } });
        obs.unobserve(en.target);
      });
    }, { threshold: 0.3 });
    io.observe(section);
  };

  // Carrousel mobile des composés
  inits['.compounds-section'] = function (section) {
    var track = qs(section, '.compounds-carousel-track');
    var slides = qsa(section, '.compounds-carousel-slide');
    var prev = qs(section, '.compounds-nav-prev'), next = qs(section, '.compounds-nav-next');
    if (!track || !slides.length || !prev || !next) return;
    var i = 0, w = 85, gap = 16;
    var update = function () { track.style.transform = 'translateX(calc(-' + i + ' * (' + w + '% + ' + gap + 'px)))'; };
    prev.addEventListener('click', function () { i = i === 0 ? slides.length - 1 : i - 1; update(); });
    next.addEventListener('click', function () { i = i === slides.length - 1 ? 0 : i + 1; update(); });
  };

  // Témoignages écrits (slider + défilé photos)
  inits['.review-section'] = function (section) {
    KV.run(function (Swiper) {
      var el = qs(section, '.ts-review-swiper');
      if (el) {
        if (el.swiper) el.swiper.destroy(true, true);
        new Swiper(el, {
          slidesPerView: 1, spaceBetween: 20, loop: true,
          navigation: { nextEl: qs(section, '.ts-next'), prevEl: qs(section, '.ts-prev') },
          pagination: { el: qs(section, '.ts-pagination'), clickable: true },
          breakpoints: { 768: { slidesPerView: 3 } }
        });
      }
    });
    var track = qs(section, '.ts-marquee-track');
    if (track && track.children.length) {
      var all = Array.prototype.slice.call(track.children), baseSets = parseInt(track.dataset.sets, 10) || 2;
      var origLen = Math.floor(all.length / baseSets) || all.length;
      var orig = all.slice(0, origLen), safety = 30;
      while (track.scrollWidth < window.innerWidth * 2 && safety-- > 0) orig.forEach(function (it) { track.appendChild(it.cloneNode(true)); });
      var sets = track.children.length / origLen;
      track.style.setProperty('--marquee-end', '-' + (100 / sets).toFixed(4) + '%');
      track.style.animationDuration = Math.round(origLen * 2.2) + 's';
    }
  };

  // Bienfaits – accordéons
  inits['.proven-benefits-section'] = function (section) {
    qsa(section, '.faq_question').forEach(function (q) {
      q.addEventListener('click', function () {
        var wasActive = q.classList.contains('active');
        qsa(section, '.faq_question').forEach(function (o) {
          o.classList.remove('active');
          var a = o.nextElementSibling; if (a) a.style.display = 'none';
          var card = o.closest('.faq_slider_item_new'); if (card) card.style.minHeight = '';
        });
        if (!wasActive) {
          q.classList.add('active');
          var ans = q.nextElementSibling;
          if (ans) {
            ans.style.display = 'block';
            // la réponse est superposée (carte qui se retourne) : on agrandit la carte si le texte est plus haut
            var card = q.closest('.faq_slider_item_new');
            if (card) {
              // le contenu est centré verticalement : on mesure les enfants (scrollHeight ignore le débordement vers le haut)
              var cs = getComputedStyle(ans), need = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + 6;
              Array.prototype.forEach.call(ans.children, function (c) { need += c.getBoundingClientRect().height; });
              if (need > card.clientHeight) card.style.minHeight = Math.ceil(need) + 'px';
            }
          }
        }
      });
    });
  };

  // Parcours bien-être – activation au défilement
  inits['.wellness-journey-section'] = function (section) {
    var items = qsa(section, '.milestone-item');
    var check = function () {
      var bottom = window.pageYOffset + window.innerHeight;
      items.forEach(function (it) {
        var r = it.getBoundingClientRect();
        var elemBottom = r.bottom + window.pageYOffset;
        it.classList.toggle('active', bottom >= elemBottom + 200);
      });
    };
    window.addEventListener('scroll', check, { passive: true });
    check();
  };

  // 5 raisons – swiper
  inits['.benefits-section-wrapper'] = function (section) {
    KV.run(function (Swiper) {
      var el = qs(section, '.benefits-swiper');
      if (!el) return;
      if (el.swiper) el.swiper.destroy(true, true);
      new Swiper(el, {
        slidesPerView: 1, spaceBetween: 12, loop: true,
        navigation: { prevEl: qs(section, '.benefits-prev'), nextEl: qs(section, '.benefits-next') },
        pagination: { el: qs(section, '.benefits-pagination'), clickable: true },
        breakpoints: { 768: { slidesPerView: 3, spaceBetween: 12 } }
      });
    });
  };

  // Vidéos témoignages #2
  inits['.video-testimonials'] = function (section) {
    KV.run(function (Swiper) {
      var el = qs(section, '.testimonial-swiper');
      if (!el) return;
      if (el.swiper) el.swiper.destroy(true, true);
      var n = qsa(el, '.swiper-slide').length, big = Math.min(6, n), mid = Math.min(4, n);
      var sw = new Swiper(el, {
        slidesPerView: big, slidesPerGroup: 2, spaceBetween: 0, loop: n > 6,
        pagination: { el: qs(el, '.vt-pagination'), clickable: true },
        breakpoints: { 0: { slidesPerView: 3, slidesPerGroup: 1 }, 768: { slidesPerView: 3, slidesPerGroup: 1 }, 1024: { slidesPerView: mid, slidesPerGroup: 2 }, 1200: { slidesPerView: big, slidesPerGroup: 2 } }
      });
      var prev = qs(section, '.vt-prev'), next = qs(section, '.vt-next');
      if (prev) prev.addEventListener('click', function () { sw.slidePrev(); });
      if (next) next.addEventListener('click', function () { sw.slideNext(); });
    });
  };

  // Avis écrits – "lire plus" (mobile)
  inits['.testimonial-section'] = function (section) {
    var btn = qs(section, '.read-more-btn'), hidden = qsa(section, '.hidden-review');
    if (!btn || !hidden.length) return;
    var more = btn.getAttribute('data-more') || btn.textContent, less = btn.getAttribute('data-less') || btn.textContent;
    btn.addEventListener('click', function () {
      var expanded = btn.classList.toggle('expanded');
      hidden.forEach(function (el) { el.classList.toggle('show', expanded); });
      btn.textContent = expanded ? less : more;
    });
  };

  function initAll(root) {
    Object.keys(inits).forEach(function (sel) {
      qsa(root || document, sel).forEach(function (section) {
        if (section.dataset.kvInit === '1') return;
        section.dataset.kvInit = '1';
        try { inits[sel](section); } catch (e) { console.error('[KV] init', sel, e); }
      });
    });
    setupScrollProAnchor();
  }

  /* ---------------------------------------------------------------- ancre #scroll-pro (CTA "Essayez sans risque") */
  function setupScrollProAnchor() {
    var old = document.getElementById('scroll-pro');
    if (old && old.classList.contains('dd-auto-anchor')) old.remove();
    var sections = qsa(document, '.shopify-section').filter(function (s) { return s.querySelector('.product-section'); });
    if (!sections.length) return;
    var target = sections[0];
    var span = document.createElement('span');
    span.id = 'scroll-pro'; span.className = 'dd-auto-anchor';
    span.style.cssText = 'display:block;position:relative;top:-80px;visibility:hidden;pointer-events:none;';
    target.insertBefore(span, target.firstChild);
  }

  /* ---------------------------------------------------------------- <product-selector> */
  var Selector = function () { return Reflect.construct(HTMLElement, [], Selector); };
  Selector.prototype = Object.create(HTMLElement.prototype);
  Selector.prototype.constructor = Selector;

  Selector.prototype.connectedCallback = function () {
    if (this._init) { this.initSwipers(); return; }
    this._init = true;
    var cfgEl = qs(this, '[data-product-selector-config]');
    try { this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { this.cfg = {}; }
    this.sectionId = this.cfg.sectionId || this.dataset.sectionId;
    this.setInitialActiveOffer();
    this.initSwipers();
    this.initOrderDate();
    this.initSoldProgressBar();
    this.initFaqAccordion();
    this.initOfferSelector();
    setupScrollProAnchor();
  };

  Selector.prototype.disconnectedCallback = function () {
    if (this._soldRaf) cancelAnimationFrame(this._soldRaf);
    qsa(this, '.swiper').forEach(function (el) { if (el.swiper) el.swiper.destroy(true, true); });
  };

  Selector.prototype.activeIndex = function () {
    var idx = -1;
    qsa(this, '.offer-box').forEach(function (b, i) { if (b.classList.contains('active')) idx = i; });
    return idx;
  };

  Selector.prototype.setInitialActiveOffer = function () {
    var c = new URLSearchParams(window.location.search).get('count');
    if (!c || ['1', '2', '3'].indexOf(c) < 0) c = String(this.cfg.defaultOffer || 2);
    var i = parseInt(c, 10) - 1;
    var boxes = qsa(this, '.bundle-offerss .offer-box');
    if (boxes[i]) boxes[i].classList.add('active');
    else if (boxes[0]) boxes[0].classList.add('active');
  };

  Selector.prototype.initSwipers = function () {
    var self = this;
    KV.run(function (Swiper) {
      if (!self.isConnected) return;
      var main = qs(self, '.product-swiper-main'), thumbs = qs(self, '.product-swiper-thumbs');
      var prev = qs(self, '.swiper-thumb-prev'), next = qs(self, '.swiper-thumb-next');
      if (main && thumbs) {
        if (main.swiper) main.swiper.destroy(true, true);
        if (thumbs.swiper) thumbs.swiper.destroy(true, true);
        var t = new Swiper(thumbs, { slidesPerView: 5, spaceBetween: 4, watchSlidesProgress: true, slideToClickedSlide: true });
        new Swiper(main, { slidesPerView: 1, spaceBetween: 0, loop: true, navigation: { nextEl: next, prevEl: prev }, thumbs: { swiper: t } });
      }
      var vt = qs(self, '.oo-vt-swiper');
      if (vt) {
        if (vt.swiper) vt.swiper.destroy(true, true);
        var count = qsa(vt, '.swiper-slide').length;
        new Swiper(vt, { slidesPerView: 3, spaceBetween: 16, loop: count > 3, navigation: { prevEl: qs(self, '.oo-vt-prev'), nextEl: qs(self, '.oo-vt-next') } });
      }
    });
  };

  Selector.prototype.initOrderDate = function () {
    var el = qs(this, '.order-date .date-text');
    if (!el) return;
    var days = parseInt(this.cfg.deliveryDays || '3', 10) || 3;
    var d = new Date(); d.setDate(d.getDate() + days);
    var locale = this.cfg.locale || 'fr-CA';
    var wd = d.toLocaleString(locale, { weekday: 'short' }), mo = d.toLocaleString(locale, { month: 'short' });
    el.textContent = wd + ' ' + d.getDate() + ' ' + mo;
  };

  Selector.prototype.initSoldProgressBar = function () {
    var self = this, bar = qs(this, '.sold-progress-bar');
    if (!bar) return;
    var fill = qs(bar, '.sold-progress-bar__fill'), label = qs(bar, '.sold-progress-bar__percentage');
    var target = parseInt(bar.dataset.soldPercent, 10);
    var tpl = bar.dataset.soldLabel || '[percent]% vendu';
    if (!fill || !isFinite(target) || target < 0) return;
    fill.style.width = '0%';
    if (label) label.textContent = tpl.replace('[percent]', '0');
    requestAnimationFrame(function () {
      fill.style.width = target + '%';
      var start = performance.now();
      var step = function (now) {
        var p = Math.max(0, Math.min(1, (now - start) / 5000));
        var v = Math.round(target * easeOutCubic(p));
        if (label) label.textContent = tpl.replace('[percent]', String(v));
        if (p < 1) self._soldRaf = requestAnimationFrame(step);
      };
      self._soldRaf = requestAnimationFrame(step);
    });
  };

  Selector.prototype.initFaqAccordion = function () {
    var items = qsa(this, '.faq-items');
    items.forEach(function (item) {
      var btn = qs(item, '.faq-questions'); if (!btn) return;
      var icon = qs(btn, '.toggle-icons');
      var answer = qs(item, '.faq-answers');
      btn.addEventListener('click', function () {
        var was = item.classList.contains('active');
        items.forEach(function (o) {
          o.classList.remove('active');
          var b = qs(o, '.faq-questions'); if (b) b.classList.remove('active');
          var a = qs(o, '.faq-answers'); if (a) a.style.display = 'none';
          var i = qs(o, '.toggle-icons'); if (i) i.textContent = '+';
        });
        if (!was) {
          item.classList.add('active'); btn.classList.add('active');
          if (answer) answer.style.display = 'block';
          if (icon) icon.textContent = '−';
        }
      });
    });
  };

  Selector.prototype.initOfferSelector = function () {
    var self = this;
    var boxes = qsa(this, '.offer-box');
    var atc = qs(this, '.add-to-cart-button');
    var priceRows = qs(this, '.price-rows');
    var hidden = qs(this, '[data-kv-offer-inputs]');
    var giftRow = qs(this, '[data-ggd-row]');
    var giftBox = giftRow && giftRow.closest('[data-ggd-box]');

    function active() { return qs(self, '.offer-box.active'); }

    function updateGifts() {
      if (!giftRow) return;
      var t = self.activeIndex() + 1;
      var unlocked = 0;
      qsa(giftRow, '.ggd-item').forEach(function (it) {
        var locked = (parseInt(it.dataset.ggdUnlock, 10) || 1) > t;
        it.classList.toggle('ggd-locked', locked);
        if (!locked) unlocked += 1;
      });
      if (giftBox) {
        var s = Math.min(Math.max(t, 1), 3);
        giftBox.dataset.ggdActive = String(s);
        var f = qs(giftBox, '[data-ggd-progress-fill]');
        if (f) f.style.width = Math.round(s / 3 * 100) + '%';
      }
    }

    function updatePrices() {
      var a = active(); if (!a) return;
      var price = a.dataset.price || '', compare = a.dataset.comparePrice || '', save = a.dataset.savePrice || '';
      qsa(self, '.add-to-cart-button .main-price').forEach(function (e) { e.textContent = price; });
      qsa(self, '.add-to-cart-button .compare-price').forEach(function (e) { e.textContent = compare; });
      if (priceRows) {
        var p = qs(priceRows, '.price'), c = qs(priceRows, '.compare-price'), s = qs(priceRows, '[data-kv-save]');
        if (p) p.textContent = price;
        if (c) c.textContent = compare;
        if (s) s.textContent = save;
      }
      if (hidden) {
        var id = qs(hidden, 'input[name="id"]'); if (id) id.value = a.dataset.variantId;
        var sp = qs(hidden, 'input[name="selling_plan"]'); if (sp) sp.value = a.dataset.sellingPlanId || '';
      }
    }

    function updateCallouts() {
      boxes.forEach(function (b) {
        var on = b.classList.contains('active');
        qsa(b, '.offer-gift-callout').forEach(function (c) { c.style.display = on ? 'flex' : 'none'; });
      });
    }

    function updateUrl() {
      var i = self.activeIndex();
      if (i < 0 || self.cfg.purchaseModuleOnly) return;
      try {
        var p = new URLSearchParams(window.location.search); p.set('count', String(i + 1));
        window.history.replaceState({}, '', window.location.pathname + '?' + p.toString());
      } catch (e) {}
    }

    function swapHero(box) {
      var m = box.dataset.heroImageMain, t = box.dataset.heroImageThumb;
      if (m) { var mainSlide = qs(self, '[data-hero-slide="main"] img'); if (mainSlide) { mainSlide.src = m; mainSlide.srcset = ''; } }
      if (t) { var thumbSlide = qs(self, '[data-hero-slide="thumb"] img'); if (thumbSlide) { thumbSlide.src = t; thumbSlide.srcset = ''; } }
      var ms = qs(self, '.product-swiper-main'), ts = qs(self, '.product-swiper-thumbs');
      if (ms && ms.swiper) ms.swiper.slideToLoop(0);
      if (ts && ts.swiper) ts.swiper.slideTo(0);
    }

    boxes.forEach(function (b) {
      b.addEventListener('click', function () {
        boxes.forEach(function (o) { o.classList.remove('active'); });
        b.classList.add('active');
        updateUrl(); updatePrices(); updateCallouts(); updateGifts(); swapHero(b);
      });
    });

    var a0 = active();
    if (a0) swapHero(a0);
    updatePrices(); updateCallouts(); updateGifts();

    /* ---- panier (Shrine cart-drawer) */
    function setLoading(on) {
      if (!atc) return;
      atc.classList.toggle('loading_hk', on);
      atc.disabled = on;
      atc.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    function itemsFor(box) {
      var main = { id: parseInt(box.dataset.variantId, 10), quantity: parseInt(box.dataset.quantity || '1', 10) || 1 };
      /* Abonnement imposé : la variante part toujours avec son selling plan Recharge.
         Les cadeaux n'en ont pas et restent en achat unique. */
      var sellingPlan = parseInt(box.dataset.sellingPlanId, 10);
      if (sellingPlan) main.selling_plan = sellingPlan;
      var items = [main];
      qsa(box, '.pdp-main__offer-gift').forEach(function (g) {
        var id = parseInt(g.dataset.giftId, 10);
        if (id) items.push({ id: id, quantity: parseInt(g.dataset.giftQuantity, 10) || 1, properties: { _cadeau: 'oui' } });
      });
      return items;
    }
    function openDrawer(json) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && json && json.sections) {
        try {
          drawer.renderContents(json);
          // Shrine masque le contenu tant que la classe "is-empty" est présente.
          var drawerEl = document.querySelector('cart-drawer.drawer');
          if (drawerEl) drawerEl.classList.remove('is-empty');
          return;
        } catch (e) { /* fallthrough */ }
      }
      window.location.href = self.cfg.cartUrl || '/cart';
    }
    function addToCart(box) {
      var items = itemsFor(box);
      // Racine localisée (« / » ou « /en/ ») : le panier et le checkout restent dans la langue de la page.
      var root = self.cfg.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // routes.root_url vaut « /en » sans barre finale : on la normalise pour obtenir « /en/cart/add.js ».
      if (root.charAt(root.length - 1) !== '/') { root += '/'; }
      var errorAdd = self.cfg.errorAdd || 'Erreur lors de l\'ajout au panier.';
      var payload = { items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
      setLoading(true);
      var go = function () {
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json(); })
          .then(function (json) {
            setLoading(false);
            if (json && json.status && json.status >= 400) { alert(json.description || json.message || errorAdd); return; }
            if (self.cfg.redirectToCheckout) { window.location.href = root + 'checkout'; return; }
            openDrawer(json);
          })
          .catch(function () { setLoading(false); alert(errorAdd); });
      };
      if (atc && atc.dataset.clearCart === 'true') {
        fetch(root + 'cart/clear.js', { method: 'POST' }).then(go, go);
      } else go();
    }
    if (atc) atc.addEventListener('click', function () { if (atc.disabled) return; var b = active(); if (b) addToCart(b); });
  };

  if (!customElements.get('product-selector')) customElements.define('product-selector', Selector);

  /* ---------------------------------------------------------------- boot */
  KV.onReady(function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target; if (!root) return;
    qsa(root, '[data-kv-init]').forEach(function (el) { delete el.dataset.kvInit; });
    initAll(root);
  });
})();
